import React from 'react';
import styled from 'styled-components';

import { StyledImage } from './Styles';

import config from '../helpers/config';

const Container = styled.section`
  text-align: center;
  font-family: Rubik;
  color: #404960;

  h1,
  a {
    color: #6048f3;
  }

  h1 {
    font-weight: 500;
    font-size: 4rem;
  }

  h2 {
    font-size: 3rem;
  }

  img {
    margin-top: 20px;
    max-width: 80%;
  }
`;

const NotFound = () => (
  <Container data-cy="404">
    <link
      href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&amp;display=swap"
      rel="stylesheet"
    />
    <h1>Oh no!</h1>
    <h2>This link is invalid</h2>
    <p>
      If you are the owner of this flow, log in to your&nbsp;
      <a href={config.appBaseURLs.admin}>
        {config.appBaseURLs.admin.substr(config.appBaseURLs.admin.indexOf('://') + 3)}
      </a>
      &nbsp; account to re-access your flow.
    </p>
    <StyledImage src="/404.png" alt="Page Not Found" />
  </Container>
);

export default NotFound;
